var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox, Page, Spinner, Tooltip, } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import { useCallback, useEffect, useRef } from 'react';
import { useForm, useFormContext } from 'react-hook-form';
import { integrationsApi, } from 'apis/integrations';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { isResponseWithData } from 'utils/apis/axios';
import { articles } from 'utils/elevio';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { SettingsIntegrationsDocumentationButton } from '../../../../../../components/documentationButton/documentationButton';
import { cardV2 } from '../../../../cards.types';
import { CardsTestResult } from '../../../components/cardsTestResult/cardsTestResult';
import { CustomCardsForm } from '../../components/form/settingsIntegrationsCardsCustomForm';
import { getAuthorizationHeaderType } from '../../utils/getAuthorizationType/getAuthorizationType';
/** Edit custom cards page. */
export const SettingsIntegrationsCardsCustomEditView = () => {
    const { id } = useAppPathParams('/settings/integrations/custom-card/edit/:id');
    const dispatch = useAppDispatch();
    const navigate = useAppNavigate();
    const notify = useNotifications();
    const scrollRef = useRef(null);
    const { control, handleSubmit, reset } = useForm({
        mode: 'onTouched',
    });
    const { formState: { isDirty: isOAuthFormDirty }, } = useFormContext();
    const disableCustomCardSaveButton = isOAuthFormDirty;
    const [getCustomCardById, { data, isLoading }] = integrationsApi.useLazyReadCustomCardIntegrationByIdQuery();
    const [updateCustomCard] = integrationsApi.useUpdateCustomCardIntegrationMutation();
    const [deleteCustomCard] = integrationsApi.useDeleteCustomCardIntegrationMutation();
    const [updateCustomCardTest, { data: testResult, isLoading: isTestLoading, isError: hasTestFailed },] = integrationsApi.useUpdateCustomCardTestIntegrationMutation();
    useEffect(() => {
        if (id) {
            getCustomCardById({ hookId: id });
        }
    }, [id]);
    // We need to reset the form values when the data is available, since the
    // custom card is fetched async (instead of using defaultValues).
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (data === null || data === void 0 ? void 0 : data.data) {
            const customCard = data.data;
            const headers = (_a = customCard === null || customCard === void 0 ? void 0 : customCard.request) === null || _a === void 0 ? void 0 : _a.headers;
            const authenticationKey = headers &&
                Object.keys(headers).find((key) => key.toLowerCase() === 'authorization');
            reset(Object.assign(Object.assign({ id: customCard.id, title: customCard.title, created_at: customCard.created_at, card_version: customCard.card_version, integration_type: customCard.integration_type, template: customCard.template, request: Object.assign(Object.assign({}, customCard.request), { uri_template: (_b = customCard === null || customCard === void 0 ? void 0 : customCard.request) === null || _b === void 0 ? void 0 : _b.uri_template, headers: (_d = (_c = customCard === null || customCard === void 0 ? void 0 : customCard.request) === null || _c === void 0 ? void 0 : _c.headers) !== null && _d !== void 0 ? _d : {}, content_type: ((_e = customCard === null || customCard === void 0 ? void 0 : customCard.request) === null || _e === void 0 ? void 0 : _e.content_type)
                        ? [customCard.request.content_type]
                        : undefined, http_method: ((_f = customCard === null || customCard === void 0 ? void 0 : customCard.request) === null || _f === void 0 ? void 0 : _f.http_method)
                        ? [customCard.request.http_method]
                        : ['GET'], o_auth_connection_id: (_g = customCard === null || customCard === void 0 ? void 0 : customCard.request) === null || _g === void 0 ? void 0 : _g.o_auth_connection_id }) }, (authenticationKey && {
                authorizationHeader: headers[authenticationKey],
            })), (headers &&
                Object.keys(headers).length > 0 && {
                customHeaders: Object.keys(headers)
                    .filter((key) => key !== authenticationKey)
                    .reduce((obj, key) => {
                    obj[key] = headers[key];
                    return obj;
                }, {}),
            })));
        }
    }, [data, reset]);
    const onSubmit = (formValues) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const authorizationHeader = formValues === null || formValues === void 0 ? void 0 : formValues.authorizationHeader;
        const customHeaders = formValues === null || formValues === void 0 ? void 0 : formValues.customHeaders;
        const uriTemplate = (_a = formValues === null || formValues === void 0 ? void 0 : formValues.request) === null || _a === void 0 ? void 0 : _a.uri_template;
        const hasUriTemplate = !!uriTemplate && uriTemplate !== '';
        const response = yield updateCustomCard(Object.assign({ id: formValues.id, created_at: formValues.created_at, title: formValues.title, template: formValues.template, card_version: cardV2, integration_type: 'custom' }, (hasUriTemplate && {
            request: {
                headers: Object.assign(Object.assign({}, (customHeaders &&
                    Object.keys(customHeaders).length > 0 && Object.assign({}, customHeaders))), (authorizationHeader && { authorization: authorizationHeader })),
                uri_template: uriTemplate,
                http_method: formValues.request.http_method[0],
                content_type: ((_c = (_b = formValues === null || formValues === void 0 ? void 0 : formValues.request) === null || _b === void 0 ? void 0 : _b.content_type) === null || _c === void 0 ? void 0 : _c[0]) || undefined,
                body: !!((_d = formValues.request) === null || _d === void 0 ? void 0 : _d.body)
                    ? formValues.request.body
                    : undefined,
                o_auth_connection_id: (_e = formValues === null || formValues === void 0 ? void 0 : formValues.request) === null || _e === void 0 ? void 0 : _e.o_auth_connection_id,
            },
        })));
        if (isResponseWithData(response)) {
            notify({
                title: 'Success',
                text: 'Custom card has been updated.',
                icon: 'i-done',
                time: 5000,
            }, NotificationType.Success);
            if (hasUriTemplate) {
                const authorizationHeaderType = getAuthorizationHeaderType(authorizationHeader) ||
                    (((_f = formValues === null || formValues === void 0 ? void 0 : formValues.request) === null || _f === void 0 ? void 0 : _f.o_auth_connection_id) && 'oauth') ||
                    undefined;
                analytics.settingsIntegrationsCustomCardEdited({
                    customHeaders: customHeaders ? Object.keys(customHeaders).length : 0,
                    authorizationHeader: authorizationHeaderType,
                    oAuthStrategy: formValues === null || formValues === void 0 ? void 0 : formValues.oAuthStrategy,
                    httpMethod: formValues.request.http_method[0],
                    contentType: ((_h = (_g = formValues === null || formValues === void 0 ? void 0 : formValues.request) === null || _g === void 0 ? void 0 : _g.content_type) === null || _h === void 0 ? void 0 : _h[0]) || undefined,
                    body: !!((_j = formValues.request) === null || _j === void 0 ? void 0 : _j.body),
                });
            }
            else {
                analytics.settingsIntegrationsCustomCardEdited();
            }
            const { data } = response;
            navigate({
                path: '/settings/integrations/custom-card/edit/:id',
                params: { path: { id: data.data.id } },
            });
        }
        else {
            notify({
                title: 'Error while updating the custom card.',
            }, NotificationType.Error);
        }
    });
    const handleTest = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        yield updateCustomCardTest({ hookId: id, template: formValues.template });
        setTimeout(() => {
            if (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) {
                scrollRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }, 300);
        analytics.settingsIntegrationsCardEditTest({
            cardType: 'custom',
            cardId: id,
        });
    }), [id, updateCustomCardTest]);
    const handleDeleteCustomCard = (customCard) => __awaiter(void 0, void 0, void 0, function* () {
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: `Delete "${customCard.title}"`,
                    description: 'Are you sure you want to delete this card?',
                    confirm: {
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            const name = customCard.title;
            try {
                yield deleteCustomCard({ hookId: customCard.id });
                notify({
                    title: 'Success',
                    text: `"${name}" has been deleted.`,
                    icon: 'i-done',
                    time: 5000,
                }, NotificationType.Success);
                navigate({ path: '/settings/integrations' });
            }
            catch (error) {
                notify({ title: `Error while deleting "${name}".` }, NotificationType.Error);
            }
        }
    });
    return (_jsx(_Fragment, { children: isLoading ? (_jsx(Spinner, {})) : (_jsx(_Fragment, { children: _jsxs(Page.Section, Object.assign({ title: "Edit custom card", titleMeta: _jsx(SettingsIntegrationsDocumentationButton, { onClick: () => elevioClient.openArticle(articles.settings.cards.custom) }), controls: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ icon: "play", variant: "secondary", onClick: () => navigate({
                                path: '/settings/integrations/custom-card/test/:id',
                                params: { path: { id } },
                            }), isLoading: isTestLoading }, { children: "Test with parameters" })), _jsx(Button, Object.assign({ icon: "trash", variant: "secondary", disabled: disableCustomCardSaveButton, onClick: () => handleDeleteCustomCard(data === null || data === void 0 ? void 0 : data.data) }, { children: "Delete card" })), _jsx(Tooltip, Object.assign({ dark: true, content: disableCustomCardSaveButton
                                ? 'The OAuth configuration needs to be saved before the card is saved'
                                : undefined }, { children: _jsx(Button, Object.assign({ disabled: disableCustomCardSaveButton, onClick: handleSubmit(onSubmit) }, { children: "Save changes" })) }))] }) }, { children: [_jsx(CustomCardsForm, { control: control, handleCustomCardSubmit: handleSubmit(onSubmit) }), _jsx(FlexBox, Object.assign({ margin: "300 0" }, { children: _jsx(Button, Object.assign({ icon: "play", variant: "primary", onClick: handleSubmit(handleTest), isLoading: isTestLoading }, { children: "Test the template" })) })), _jsx(CardsTestResult, { card: data === null || data === void 0 ? void 0 : data.data, testResult: testResult === null || testResult === void 0 ? void 0 : testResult.data, scrollRef: scrollRef, isLoading: isTestLoading, hasFailed: hasTestFailed })] })) })) }));
};
